/* eslint-disable no-console */
/* eslint-disable no-return-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable prettier/prettier */
/* eslint-disable func-names, prefer-rest-params */
(function (e, n) {
    function t(e) {
        return typeof e === 'object' ? JSON.parse(JSON.stringify(e)) : e;
    }
    e[n] = e[n] ||
    {
        nlsQ(o, r, c) {
            const s = e.document;
            const a = s.createElement('script');
            a.async = 1;
            a.src = `${e.location.protocol === 'http:' ? 'http:' : 'https:'}//cdn-gl.nmrodam.com/conf/${o}.js#name=${r}&ns=${n}`;
            const i = s.getElementsByTagName('script')[0];

            // eslint-disable-next-line no-sequences
            return i.parentNode.insertBefore(a, i),
                e[n][r] = e[n][r] || {
                    g: c || {},
                    ggPM(o, c, s, a, i) {
                        e[n][r].q = e[n][r].q || [];
                        try {
                            const l = t([o, c, s, a, i]);
                            e[n][r].q.push(l);
                        }
                        catch (e) {
                            console && console.log && console.log('Error: Cannot register event in Nielsen SDK queue.');
                        }
                    },
                    trackEvent(o) {
                        e[n][r].te = e[n][r].te || [];
                        try {
                            const c = t(o);
                            e[n][r].te.push(c);
                        }
                        catch (e) {
                            console && console.log && console.log('Error: Cannot register event in Nielsen SDK queue.');
                        }
                    },
                },
                e[n][r];
        },
    };
})(window, 'NOLBUNDLE');
